import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';

import { connect } from 'react-redux';

import EsmsDialog from '../../components/EsmsDialog';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

class DeleteContactModal extends Component {
    handleDelete = async () => {
        const { selectedNode, selectedContact } = this.props;

        let isDeleted;

        if (!this.props.isLoading) {
            this.props.toggleLoading(true);
            isDeleted = await this.props.deleteContact(selectedContact.id, selectedNode.id);
        }

        if (isDeleted) this.handleClose();
    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.toggleLoading(false);
        this.props.close();
    }

    render() {
        const {
            errors,
            isLoading,
            open,
            selectedContact,
            title
        } = this.props;

        return (
            <EsmsDialog
                errors={errors}
                open={open}
                onClose={this.handleClose}
                title={title}
                onConfirm={this.handleDelete}
                isLoading={isLoading}
                confirmText="Delete"
            >
                <p>
                    Are you sure you want to delete Contact: {selectedContact.name}?
                </p>
            </EsmsDialog>
        );
    }
}

DeleteContactModal.propTypes = {
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = state => {
    return {
        errors:          state.messages.errors,
        isLoading:       state.ui.isLoading,
        selectedNode:    state.architect.selectedNode,
        selectedContact: state.architect.selectedContact
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteContactModal);
